import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import animated from 'animate.css'
import store from './store'
import vantCom from '@/plugins/vant'

import mixin from '@/mixin'

import '@/router/intercept'

import customComs from '@/components/btns'
import '@/assets/style/index.less'

const app = createApp(App)

app.use(animated)
// vant
vantCom.forEach(component => {
  app.use(component)
})

router.afterEach(() => {
  window.scrollTo(0,0)
})

// 自定义组件
customComs.forEach(component => {
  app.component(component.name, component)
})

// mixin
for (let k in mixin) {
  app.config.globalProperties[`$${k}`] = mixin[k]
}

app.mixin(mixin)
.use(router)
.use(store)
.mount('#app')

